import { render, staticRenderFns } from "./template-projects-list.vue?vue&type=template&id=a9a012ca"
import script from "./template-projects-list.vue?vue&type=script&lang=js"
export * from "./template-projects-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports